import CityPageTemplate from "../city-template/CityPageTemplate";
import { shortPumpVaConfig } from "./data";

export default function ShortPumpVaPage() {
  return <CityPageTemplate config={shortPumpVaConfig} />;
}